/**
 * 顧客の性別を表す列挙体
 * - male: 男性
 * - female: 女性
 * - unknown: その他
 */
enum GenderEnum {
  male = "男性",
  female = "女性",
  unknown = "その他",
}

/**
 * LINE連携状態を表す列挙型
 * - notYet: 紐付けなし
 * - linked: 紐付け済み
 */
enum linkedLineStatus {
  notYet = "紐付けなし",
  linked = "紐付け済み",
}

/**
 * 顧客ステータス（一覧）
 * - all: 全顧客
 * - new: 新患
 * - existed: 既存
 * - defection: 離反
 * - hibernation: 休眠
 * - revisited: 再診
 */
const AllCustomerStatusesConstants = {
  all: "すべて",
  new: "新規",
  existed: "既存",
  defection: "離反",
  hibernation: "休眠",
  revisited: "再来",
};

/**
 * 顧客フィルターで使用される基本フィールド
 * - name: 名前
 * - code: カルテNo.
 */
const BasicCustomerFilterFields = ["name", "code"];

/**
 * LINE連携状態のフィルタリングオプション
 */
enum CustomerFilterLineBy {
  linked = "linked",
  unlinked = "unlinked",
  all = "all",
}

/**
 * 顧客ステータスのセレクトボックス用オプション一覧
 */
const CustomerStatusOptions = Object.entries(AllCustomerStatusesConstants).map(([value, name]) => ({
  name,
  value,
}));

/**
 * 顧客の重複チェックに使われるフィールドマッピング
 * 各項目に英名（en_name）と日本語名（jp_name）を含む
 */
const CustomerDuplicateCheckFields: Record<string, any> = {
  name: { en_name: "name", jp_name: "名前" },
  phone: { en_name: "phone", jp_name: "電話番号" },
  birthday: { en_name: "birthday", jp_name: "生年月日" },
};

/**
 * 顧客統合プレビュー画面で使用される項目名のラベル
 * キーはデータフィールド名、値は日本語表示用文字列
 */
const PreviewMergedCustomerFieldNames = {
  code: "カルテNo.",
  name: "名前",
  birthday: "生年月日",
  age: "年齢",
  phone: "電話番号",
  address: "住所",
  email: "メールアドレス",
  gender: "性別",
  customer_status: "顧客ステータス",
  visit_status: "来店ステータス",
  first_time_visit: "初回来店日",
  latest_time_visit: "最終来店日",
  total_visits_in_current_month: "当月内来店回数",
  visit_cycle_in_one_year: "来店周期日数",
  total_visits: "累計来店回数",
  number_of_visit: "過去来店回数",
  customer_notes: "顧客メモ",
  special_notes: "特記事項",
  system_tags: "オリジナルタグ",
  partner_tags: "RIPICLEタグ",
  penultimate_booking_services: "前回施術メニュー",
  latest_booking_services: "予約時の最新情報",
  booking_services_history: "過去の施術メニュー",
};

export {
  GenderEnum,
  linkedLineStatus,
  CustomerStatusOptions,
  BasicCustomerFilterFields,
  CustomerDuplicateCheckFields,
  PreviewMergedCustomerFieldNames,
  CustomerFilterLineBy,
};
